import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Use smooth scrolling for better UX
    });
  }, [pathname]); // Trigger on route (pathname) change

  return null; // This component doesn't render anything
};

export default ScrollToTop; 